import { render, staticRenderFns } from "./SPIFProfileProfitAndLoss.vue?vue&type=template&id=71c77e3e"
import script from "./SPIFProfileProfitAndLoss.vue?vue&type=script&lang=js"
export * from "./SPIFProfileProfitAndLoss.vue?vue&type=script&lang=js"
import style0 from "./SPIFProfileProfitAndLoss.vue?vue&type=style&index=0&id=71c77e3e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports